export const services = [
  {
    title: "Sales & Service Cloud",
    slug: "sales-service-cloud",
    desc: "Maximize productivity and customer satisfaction with customized core cloud implementations.",
    heroImage: require("./assets/images/portfolio-crm.png"),
    longDesc: "Elevate your business operations with a 360-degree view of your customer. Our Sales & Service Cloud solutions are designed to automate tedious tasks, streamline communication, and empower your teams to deliver world-class service. Whether you're looking to boost sales velocity or resolve cases faster, we provide the technical foundation to scale your success.",
    features: [
      "Custom Lead & Opportunity Management",
      "Automated Case Routing & SLAs",
      "Salesforce Maps Integration",
      "Omni-Channel Customer Support",
      "Knowledge Base Implementation"
    ],
    benefits: [
      "32% Increase in Sales Productivity",
      "45% Faster Case Resolution",
      "Improved Customer Retention Rates",
      "Real-time Pipeline Visibility"
    ],
    integrations: ["Slack", "Microsoft Outlook", "Gmail", "Twilio", "Jira"],
    whyChoose: [
      "Certified Service Cloud Consultants",
      "Proven Migration Frameworks",
      "Focus on User Adoption & Training",
      "End-to-End Project Lifecycle Support"
    ],
    industries: ["FinTech", "Healthcare", "Manufacturing", "Professional Services"]
  },
  {
    title: "MuleSoft Integration",
    slug: "mulesoft-integration",
    desc: "Connect any application, data or device with scalable API-led connectivity solutions.",
    heroImage: require("./assets/images/portfolio-integration.png"),
    longDesc: "Break down data silos and build a future-proof application network. Using MuleSoft Anypoint Platform, we enable seamless data exchange between your legacy systems, SaaS applications, and modern mobile apps. Our API-led approach ensures your integrations are reusable, scalable, and highly secure.",
    features: [
      "API Design & Management",
      "Legacy System Modernization",
      "Hybrid & Multi-cloud Connectivity",
      "Enterprise Service Bus (ESB) Setup",
      "Real-time Data Synchronization"
    ],
    benefits: [
      "Accelerated Application Delivery",
      "Reduced IT Maintenance Costs",
      "Improved Data Accuracy & Integrity",
      "Scalable Integration Architecture"
    ],
    integrations: ["SAP", "Oracle", "AWS", "Workday", "Snowflake"],
    whyChoose: [
      "API-Led Connectivity Experts",
      "Complex Data Mapping Specialists",
      "Security-First Architecture",
      "Performance Optimization Focus"
    ],
    industries: ["Banking", "Retail", "Life Sciences", "Logistics"]
  },
  {
    title: "Tableau & Analytics",
    slug: "tableau-analytics",
    desc: "Transform raw CRM data into actionable business intelligence using Einstein and Tableau.",
    heroImage: require("./assets/images/portfolio-ai.png"),
    longDesc: "Don't just collect data—command it. We help you transform raw Salesforce data into interactive, visual stories that drive strategic action. By combining Tableau's power with Einstein AI, we uncover predictive insights that guide your next big move, ensuring every decision is backed by intelligence.",
    features: [
      "Interactive Dashboard Design",
      "Predictive Analytics with Einstein AI",
      "Data Cleaning & Transformation",
      "Cross-Platform Data Integration",
      "Automated Reporting & Alerts"
    ],
    benefits: [
      "Increased Operational Efficiency",
      "Early Identification of Sales Trends",
      "Data-Backed Strategic Planning",
      "Self-Service Analytics for Teams"
    ],
    integrations: ["Google BigQuery", "Amazon S3", "Azure Data Lake", "NetSuite", "HubSpot"],
    whyChoose: [
      "Data Storytelling Specialists",
      "Statistical Analysis Expertise",
      "Einstein AI Implementation Pros",
      "Custom Data Connector Dev"
    ],
    industries: ["Financial Services", "Energy", "Entertainment", "E-commerce"]
  },
  {
    title: "Marketing Cloud",
    slug: "marketing-cloud",
    desc: "Design personalized customer journeys and automate cross-channel marketing campaigns.",
    heroImage: require("./assets/images/hero-bg.png"),
    longDesc: "Turn every customer interaction into a meaningful relationship. We leverage Salesforce Marketing Cloud to build hyper-personalized journeys across email, mobile, and social. From audience segmentation to automated triggers, we ensure your brand message reaches the right person at the exactly right moment.",
    features: [
      "Journey Builder Orchestration",
      "Email Studio & Automation",
      "Interaction Studio Personalization",
      "Audience Segmentation & Scoring",
      "Marketing ROI Tracking"
    ],
    benefits: [
      "Higher Campaign Conversion Rates",
      "Improved Customer Engagement",
      "Unified Brand Experience",
      "Reduced Manual Marketing Effort"
    ],
    integrations: ["Facebook Ads", "Google Ads", "LinkedIn", "Shopify", "Mailchimp"],
    whyChoose: [
      "Omni-channel Strategy Experts",
      "Marketing Automation Scientists",
      "Custom SQL / Ampscript Proficiency",
      "Data-Driven Campaign Optimization"
    ],
    industries: ["Hospitality", "Automotive", "CPG", "Media"]
  },
  {
    title: "Commerce Cloud",
    slug: "commerce-cloud",
    desc: "Build unified, intelligent B2B and B2C shopping experiences across all channels.",
    heroImage: "https://images.unsplash.com/photo-1472851294608-062f824d29cc?q=80&w=2670&auto=format&fit=crop",
    longDesc: "Reimagine the digital shopping experience. Whether you're B2B or B2C, we implement Commerce Cloud solutions that drive conversion and loyalty. From AI-driven product recommendations to seamless headless commerce architectures, we build online stores that scale with your global ambitions.",
    features: [
      "B2B & B2C Storefront Setup",
      "AI-Powered Product Recommendations",
      "Order Management Integration",
      "Multi-currency & Language Support",
      "Mobile-First Commerce Design"
    ],
    benefits: [
      "Increased Average Order Value",
      "Reduced Cart Abandonment",
      "Global Market Expansion",
      "Unified Commerce View"
    ],
    integrations: ["Stripe", "PayPal", "FedEx", "Avalara", "Contentful"],
    whyChoose: [
      "E-commerce Transformation Leaders",
      "Headless Commerce Specialists",
      "Global Rollout Experience",
      "UI/UX Conversion Optimization"
    ],
    industries: ["Fashion", "Electronics", "Grocer", "Home Goods"]
  },
  {
    title: "Platform & LWC",
    slug: "platform-lwc",
    desc: "Develop custom Lightning Web Components and scalable backend logic on the Salesforce platform.",
    heroImage: require("./assets/images/portfolio-cpq.png"),
    longDesc: "If you can dream it, we can build it on the Salesforce platform. We specialize in pushing the boundaries of what's possible with custom LWC development and advanced Apex logic. Our solutions are robust, scalable, and designed to provide a tailored user experience that standard features simply can't match.",
    features: [
      "Custom LWC Development",
      "Apex Trigger & Batch Jobs",
      "Salesforce Flow Automation",
      "AppExchange Product Development",
      "Platform Event Integration"
    ],
    benefits: [
      "Tailored User Experience",
      "Automated Complex Business Logic",
      "Higher User Adoption Rates",
      "Future-Proof Technical Foundation"
    ],
    integrations: ["Heroku", "GitHub", "Vercel", "Slack SDK", "Microsoft Azure"],
    whyChoose: [
      "Full-Stack Salesforce Developers",
      "Performance & Scalability Gurus",
      "Modern Web Standard Adoption",
      "Complex Architecture Problem Solvers"
    ],
    industries: ["Tech & SaaS", "Non-Profit", "Education", "Government"]
  }
];